{#if node}
  {#if template.nodeIs(node, ROOT)}
    {#if $store.render.inlineCSS}
      <svelte:element this="style">{$store.render.inlineCSS}</svelte:element>
    {/if}

    <div class={cmsClasses || null}>
      <div class="cms-main cms-root {allModeClasses}">
        <div class="sortable-parent cms-root__inner" data-type={ifLoggedIn('root')}>
          {#each (node.block.nodes || []) as node (node.id)}
            <svelte:self {...template.renderProps(render, node)} />
          {/each}
        </div>
      </div>
    </div>

    <script src="/api/legacy/resources/templates/{$store.render.template.id}/script.js?c={$store.cacheBust}" async defer nonce="{$store.nonce}"></script>
    <link id="styles-above-the-fold" rel="stylesheet" href="/api/legacy/resources/templates/{$store.render.template.id}/inline.css?c={$store.cacheBust}" on:load={() => { $store.render.inlineCSS = '' }}>
    <link id="external-styles" rel="stylesheet" href="/api/legacy/resources/templates/{$store.render.template.id}/external.css?c={$store.cacheBust}">
  {:else if template.nodeIs(node, LAYOUT)}
    <div on:click={e => nodeClick(e, node)} class="{nodeClasses} sortable-item sortable-plugin" data-node-id={ifLoggedIn(node.id)} data-target={dataTarget}>
      {#each (node.block.nodes || []) as node (node.id)}
        <div class={blockClasses()} data-block-id={ifLoggedIn(template.childBlockId(render, node))}>
          <svelte:self {...template.renderProps(render, node)} />
        </div>
      {/each}
    </div>
  {:else if template.nodeIs(node, ROW_BRANCH, ROW, COL, COL_UNIQUE, COL_SHARED)}
    <Components.Element on:click={e => nodeClick(e, node)} id={nodeIds()} className={nodeClasses} {...template.nodeProps(render, node, { dataTarget, nodeId: node.id, dataAllowBackground: node.fields?.allowBackground })}>
      {#if node.fields && node.fields.allowBackground && (nodeVideoMp4 || nodeBackgroundImage || nodeMaskText)}
        {#if nodeVideoUrl && !isMobile}
          <div class="cms-iframe-container">
            <iframe
              src={nodeVideoUrl}
              seamless
              playsinline
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              class="cms-background-iframe"
              style="border: none;width:100%;"
              title="background video"
            />
          </div>
        {/if}

        {#if nodeVideoMp4 && !isMobile}
          <video
            class="cms-background-video"
            poster={nodeBackgroundImage}
            muted
            autoplay
            loop={nodeVideoLoop}
          >
            <source src={nodeVideoMp4} type="video/mp4">
          </video>
        {/if}

        {#if nodeMobileImage && isMobile}
          <div class="cms-background-image">
            <Components.LazyImg src={nodeMobileImage} alt="background" />
          </div>
        {/if}

        {#if nodeParallax}
          <div class="cms-background-parallax parallax">
            <Components.LazyImg src={nodeBackgroundImage} alt="background" />
          </div>
        {:else if nodeBackgroundImage && nodeBackgroundImage !== '?size=xl'}
          <div class="cms-background-image">
            <Components.LazyImg src={nodeBackgroundImage} alt="background" />
          </div>
        {/if}

        {#if nodeMaskText}
          <svg class="svg-mask" preserveAspectRatio="none">
            <defs>
              <mask id="mask-{node.id}" x="0" y="0" width="100%" height="100%" >
                <rect class="alpha" x="0" y="0" width="100%" height="100%"/>
                <text class="text" x="0" y="0" dx={nodeMaskPositionX} dy={nodeMaskPositionY}>{nodeMaskText}</text>
              </mask>
            </defs>
            <rect class="base" x="0" y="0" width="100%" height="100%"/>
          </svg>
        {/if}
      {/if}

      <div
        class={blockClasses()}
        data-block-id={ifLoggedIn(template.childBlockId(render, node))}
        data-type={ifLoggedIn(node.type)}
      >
        {#each (template.nodes(render, node) || []) as node (node.id)}
          <svelte:self {...template.renderProps(render, node)} />
        {/each}
      </div>
    </Components.Element>
  {:else if template.nodeIs(node, PLUGIN)}
    {#if node.fields?.href && ![modes.EDIT, modes.DELETE, modes.SORT].includes($store.editor.mode)}
      <a
        href={node.fields.href}
        target={node.fields.hrefTarget}
        class:cms-plugin--editing-inline={editingInline}
        class={pluginClasses()}
        data-plugin-ref={ifLoggedIn(render.plugins[node.pluginId].ref)}
        data-plugin-id={ifLoggedIn(node.pluginId)}
        data-node-id={ifLoggedIn(node.id)}
      >
        {#if isEditMode() && $store.editor.editPluginInline.component && $store.editor.editPluginInline.id === node.pluginId}
          <svelte:component
            this={$store.editor.editPluginInline.component}
            bind:this={$store.editor.editPluginInline.instance}
            pluginId={node.pluginId}
            {...template.pluginProps(render, node)}
          />
        {:else}
          <Components.Plugin {...template.renderProps(render, node)} />
        {/if}
      </a>
    {:else}
      <div
        class:cms-plugin--editing-inline={editingInline}
        class={pluginClasses()}
        data-plugin-ref={ifLoggedIn(render.plugins[node.pluginId].ref)}
        data-plugin-id={ifLoggedIn(node.pluginId)}
        data-node-id={ifLoggedIn(node.id)}
      >
        {#if isEditMode() && $store.editor.editPluginInline.component && $store.editor.editPluginInline.id === node.pluginId}
          <svelte:component
            this={$store.editor.editPluginInline.component}
            bind:this={$store.editor.editPluginInline.instance}
            pluginId={node.pluginId}
            {...template.pluginProps(render, node)}
          />
        {:else}
          <Components.Plugin {...template.renderProps(render, node)} />
        {/if}
      </div>
    {/if}
  {/if}
{/if}

<svelte:window bind:innerWidth={windowWidth} />

<script context="module">export const svelteCompilerVersion = {"major":4,"minor":2,"patch":18};
  export const Components = {
    load: [
      'core/extensions/element/v1.0.0/Element',
      'core/extensions/lazy_img/v1.0.0/LazyImg',
      'core/extensions/plugin/v1.0.0/Plugin',
      'core/extensions/alert_box/v1.0.0/AlertBox',
    ],
  }
</script>

<script>
  import { getContext } from 'svelte'

  export let render
  export let node
  export let cmsClasses = ''

  const platform = getContext('platform')
  const { store } = platform
  const { url } = platform.router
  const { template } = platform.api.core
  const { ROOT, LAYOUT, ROW_BRANCH, ROW, COL, COL_UNIQUE, COL_SHARED, PLUGIN } = platform.api.core.template
  let nodeFields = template.nodeFields(render, node)
  let windowWidth = null
  $: nodeFields = template.nodeFields(render, node)
  const isLoggedIn = platform.api.core.isLoggedIn()

  const { modes, isMode } = platform.api.cms.editor
  const types = platform.api.core.template

  $: nodeBackgroundImage = `${(nodeFields.backgroundImage || '').split('?').shift()}?size=xl`
  $: nodeMobileImage = nodeFields.backgroundMobileImage || ''
  $: nodeMaskPositionX = nodeFields.backgroundMaskPositionX
  $: nodeMaskPositionY = nodeFields.backgroundMaskPositionY
  $: nodeMaskText = nodeFields.backgroundMaskText
  $: nodeParallax = nodeFields.backgroundParallax
  $: nodeVideoLoop = nodeFields.backgroundVideoLoop
  $: nodeVideoMp4 = nodeFields.backgroundVideoMp4
  $: nodeVideoUrl = nodeFields.backgroundVideoUrl
  $: isMobile = windowWidth <= 1048
  let editingInline = false

  $: if ($store.editor.editPluginInline.component && $store.editor.editPluginInline.id === node.pluginId && $store.editor.mode === modes.EDIT) {
    editingInline = true
  }

  let nodeClasses = getNodeClasses()

  $: if ($url.pathname && node) {
    nodeClasses = getNodeClasses()
  }

  $: if ($store.editor.nodeFocus || $store.editor.node || node.type || $store.editor.background) {
    nodeClasses = getNodeClasses()

    render = render
    node = node
  } else {
    nodeClasses = getNodeClasses()
  }

  function getNodeClasses () {
    let classes = []

    if (!node.type) {
      return classes.join(' ')
    }

    if ($store.editor.nodeFocus === node.id) {
      classes.push('cms-focus-node')
    }

    if (node.fields && node.fields.allowBackground) {
      classes.push('cms-background')
    }

    if (node.type?.startsWith('col-')) {
      classes.push('cms-col')
    }

    if (node.type?.startsWith('row') && node.block && template.nodes(render, node)) {
      classes.push(`cms-row--ncols-${template.nodes(render, node).length}`)
    }

    if (nodeFields && nodeFields.backgroundVideoMp4) {
      classes.push('cms-background-video-container')
    }

    if (nodeFields && nodeFields.backgroundParallax) {
      classes.push('parallax-container')
    }

    if (nodeFields && nodeFields.backgroundOrigin === 'content-box') {
      classes.push('cms-background--content-box')
    }

    if (nodeFields && nodeFields.backgroundHover) {
      classes.push(`cms-background-hover--${nodeFields.backgroundHover}`)
    }

    const modalTypes = [
      modes.EDIT_NODE_LINK,
      modes.EDIT_NODE_BACKGROUND,
      modes.EDIT_NODE_BRANCH_BLOCK,
    ]

    if (modalTypes.indexOf($store.editor.mode) >= 0 || ($store.editor.mode === modes.EDIT && node.type === types.LAYOUT)) {
      classes.push('modal-trigger')
    }

    if (node.fields && node.fields.classNames) {
      classes = [...classes, ...node.fields.classNames]
    }

    if (nodeFields && nodeFields.classNames) {
      classes = [...classes, ...nodeFields.classNames]
    }

    classes.push(`cms-${node.type}`)

    return classes.join(' ')
  }

  function blockClasses () {
    if (!node.type) {
      return ''
    }

    const classes = []

    if (node.type.startsWith('col-')) {
      classes.push('cms-col__inner')

      if (isLoggedIn) {
        classes.push('sortable-parent')
      }
    } else if (node.type.startsWith('row-')) {
      classes.push('cms-row__inner')
    }

    if (classes.indexOf(`cms-${node.type}__inner`) < 0) {
      classes.push(`cms-${node.type}__inner`)
    }

    if ($store.editor.mode === modes.SORT) {
      classes.push('sortable-drag')
    }

    return classes.join(' ')
  }

  function pluginClasses () {
    const plugin = render.plugins[node.pluginId]

    if (!plugin) {
      return 'cms-plugin'
    }

    plugin.classNames = plugin.classNames || []

    const classes = ['cms-plugin', 'sortable-item', 'sortable-plugin', ...plugin.classNames]

    return classes.join(' ')
  }

  function ifLoggedIn (value) {
    return isLoggedIn ? value : null
  }

  $: dataTarget = nodeModalTarget($store.editor.mode)

  function nodeModalTarget () {
    switch ($store.editor.mode) {
      case modes.EDIT_NODE_LINK: return 'cms-link-editor-modal'
      case modes.EDIT_NODE_BACKGROUND: return 'cms-background-editor-modal'
      case modes.EDIT_NODE_BRANCH_BLOCK: return 'cms-branch-block-editor-modal'
      case modes.DELETE:
      case modes.EDIT:
        if (node.type === types.LAYOUT) {
          return 'cms-layout-editor-modal'
        }
    }
  }

  async function nodeClick (e, node) {
    if ($store.editor.mode !== modes.VIEW) {
      if (!node) {
        e.preventDefault()
        e.stopPropagation()

        return
      }
    }

    switch ($store.editor.mode) {
      case modes.EDIT_NODE_BACKGROUND:
        if (!e.target.dataset.allowBackground) {
          e.preventDefault()
          e.stopPropagation()

          return
        }

        if (!node.type.startsWith('row') && !node.type.startsWith('col')) {
          e.preventDefault()
          e.stopPropagation()

          return
        }

        $store.editor.background = {
          nodeId: node.id,
          textColour: nodeFields.backgroundTextColour,
          textShadow: nodeFields.backgroundTextShadow,
          maskText: nodeFields.backgroundMaskText,
          maskPositionX: nodeFields.backgroundMaskPositionX,
          maskPositionY: nodeFields.backgroundMaskPositionY,
          colour: nodeFields.backgroundColour,
          image: nodeFields.backgroundImage,
          videoMp4: nodeFields.backgroundVideoMp4,
          videoLoop: nodeFields.backgroundVideoLoop,
          videoUrl: nodeFields.backgroundVideoUrl,
          mobileImage: nodeFields.backgroundMobileImage,
          parallax: nodeFields.backgroundParallax,
        }

        $store.editor.node = node

        e.stopPropagation()

        break
    }

    if (isMode(modes.EDIT_NODE_BRANCH_BLOCK)) {
      e.preventDefault()
      e.stopPropagation()

      $store.editor.node = { id: null }
      $store.editor.block = {}

      const childBlockId = template.childBlockId(render, node)
      const block = await platform.api.cms.blocks.find(childBlockId)

      $store.editor.block = block
      $store.editor.node = node

      if (e.target.dataset.target) {
        platform.api.browser.modal(e.target.dataset.target).open()
      }

      return
    }

    if ($store.editor.mode !== modes.VIEW) {
      e.preventDefault()

      if (node.id === e.target.dataset.nodeId) {
        $store.editor.node = node
      }

      if (e.target.dataset.target && e.target.classList.contains('modal-trigger')) {
        if (e.target.dataset.target === 'cms-layout-editor-modal') {
          $store.editor.showTemplating = true
          $store.editor.templatingTab = 'Layout Editor'

          return
        }

        platform.api.browser.modal(e.target.dataset.target).open()
      }
    }
  }

  function nodeIds () {
    let ids = []

    if (node.fields && node.fields.ids) {
      ids = [...node.fields.ids]
    }

    if (nodeFields && nodeFields.ids) {
      ids = [...ids, ...nodeFields.ids]
    }

    return ids.join(' ') || ''
  }

  function isEditMode () {
    if ($store.editor.mode === modes.EDIT) {
      return true
    }

    return false
  }

  $: allModeClasses = modeClasses({ mode: $store.editor.mode, templating: $store.editor.showTemplating })

  function modeClasses ({ mode, templating }) {
    const classes = []

    if (mode === modes.EDIT_NODE_BACKGROUND) {
      classes.push('cms-mode--edit-node-background')
    }

    if (mode === modes.EDIT_NODE_BRANCH_BLOCK) {
      classes.push('cms-mode--edit-node-branch-block')
    }

    if (templating) {
      classes.push('cms-main--template-editor')
    }

    if (mode === modes.SORT) {
      classes.push('cms-mode--sort-plugin')
    }

    if (mode === modes.DELETE) {
      classes.push('cms-mode--remove-plugin')
    }

    if (mode === modes.EDIT) {
      classes.push('cms-mode--edit-plugin')
    }

    return classes.join(' ')
  }
</script>

<style>
  :global(html),
  :global(body) {
    margin: 0;
    padding: 0;
    font: 13px sans-serif;
    line-height: normal;
    background: #fff;
    color: #333;
    min-height: 100vh;
  }

  :global(html) {
    box-sizing: border-box;
    overflow-x: hidden;
  }

  :global(*),
  :global(*:before),
  :global(*:after) {
    box-sizing: inherit;
  }

  :global(a) {
    color: #039be5;
    text-decoration: none;
    -webkit-tap-highlight-color: transparent;
  }

  :global(img) {
    border: none;
    max-width: 100%;
    height: auto;
  }

  :global(.swiper-wrapper [data-lazy-src]) {
    transition: none;
  }

  :global([data-lazy-src][data-lazy-show]),
  :global([data-lazy-src].cms-lazy-show) {
    opacity: 1;
  }

  :global([data-lazy-background-src]) {
    background-image: url('/static/images/placeholder.gif');
    transition: background-image 0.3s;
  }

  :global(hr) {
    display: block;
    height: 1px;
    border: 0;
    border-top: 1px solid #ccc;
    margin: 1em 0;
    padding: 0;
  }

  :global(audio),
  :global(canvas),
  :global(iframe),
  :global(img),
  :global(svg),
  :global(video) {
    vertical-align: middle;
  }

  :global(.parallax img) {
    max-width: none;
  }

  :global(.cms-default-error) {
    text-align: center;
    font-size: 2em;
    color: #aaa;
    padding: 5% 20px 0;
  }

  :global(.cms-default-error h1) {
    color: #333;
  }

  :global(.cms-main) {
    position: relative;
  }

  :global(.cms-row__inner:before),
  :global(.cms-row__inner:after),
  :global(.cms-row-branch__inner:before),
  :global(.cms-row-branch__inner:after),
  :global(.cms-root .sortable-parent:before),
  :global(.cms-root .sortable-parent:after) {
    content: '';
    display: table;
  }

  :global(.cms-row__inner:after),
  :global(.cms-row-branch__inner:after),
  :global(.cms-root .sortable-parent:after) {
    clear: both;
  }

  :global(.cms-plugin) {
    position: relative;
    display: block;
  }

  :global(.cms-background) {
    position: relative;
    overflow: hidden;
    z-index: 1;
  }

  :global(.cms-background-image),
  :global(.cms-background-video) {
    position: absolute;
    top: 50%;
    left: 50%;
    min-width: 100%;
    min-height: 100%;
    transform: translate(-50%, -50%);
    z-index: -1;
  }

  :global(.cms-background-image img),
  :global(.cms-background-video video) {
    position: absolute;
    min-width: 100%;
    min-height: 100%;
    max-width: none;
    max-height: none;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  :global(.cms-background-video + .cms-background-image) {
    display: none;
  }

  :global(.svg-mask) {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
  }

  :global(.svg-mask text) {
    text-anchor: middle;
    transition: font-size 0.3s;
  }

  :global(.svg-mask .alpha) {
    fill: #fff;
  }

  @media screen and (max-width: 640px) {
    :global(.cms-background-video) {
      display: none;
    }

    :global(.cms-background-video + .cms-background-image) {
      display: block;
    }
  }

  :global(.parallax-container .parallax) {
    pointer-events: none;
    transition: filter 0.5s;
  }

  :global(.cms-loading) {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.8);
    color: #fff;
    text-align: center;
    padding: 20px;
    opacity: 0;
    pointer-events: none;
    z-index: 100000;
    transition: opacity 0.3s;
  }

  :global(.cms-loading__content) {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  :global(.cms-row),
  :global(.cms-row-branch) {
    clear: both;
  }

  :global(.cms-col) {
    float: left;
    min-height: 1px;
  }

  :global(.cms-row--ncols-1 > .cms-row__inner > .cms-col),
  :global(.cms-row--ncols-1 > .cms-row-branch__inner > .cms-col) {
    width: 100%;
  }

  :global(.cms-row--ncols-2 > .cms-row__inner > .cms-col),
  :global(.cms-row--ncols-2 > .cms-row-branch__inner > .cms-col) {
    width: 50%;
  }

  :global(.cms-row--ncols-3 > .cms-row__inner > .cms-col),
  :global(.cms-row--ncols-3 > .cms-row-branch__inner > .cms-col) {
    width: calc(100% / 3);
  }

  :global(.cms-row--ncols-4 > .cms-row__inner > .cms-col),
  :global(.cms-row--ncols-4 > .cms-row-branch__inner > .cms-col) {
    width: 25%;
  }

  :global(.cms-row--ncols-5 > .cms-row__inner > .cms-col),
  :global(.cms-row--ncols-5 > .cms-row-branch__inner > .cms-col) {
    width: 20%;
  }

  :global(.cms-row--ncols-6 > .cms-row__inner > .cms-col),
  :global(.cms-row--ncols-6 > .cms-row-branch__inner > .cms-col) {
    width: calc(100% / 6);
  }

  :global(.cms-node-link) {
    display: block;
  }

  :global(.cms-main--initial.cms-main--loading) {
    opacity: 0;
  }

  :global(.cms-loading--show) {
    opacity: 1;
    pointer-events: auto;
  }

  :global(.cms-td select),
  :global(.cms-td textarea),
  :global(.cms-td input) {
    width: 100%;
  }

  :global(.cms-mode--sort-plugin .sortable-parent) {
    min-height: 10px !important;
    outline: 1px dashed #ccc !important;
  }

  :global(.cms-mode--sort-plugin .cms-plugin:hover:after),
  :global(.cms-mode--remove-plugin .cms-plugin:hover:after),
  :global(.cms-mode--edit-plugin .cms-plugin:hover:after) {
    background: #3962ca86;
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    cursor: pointer;
    z-index: 1000;
  }

  :global(.cms-mode--edit-plugin .cms-plugin a) {
    pointer-events: none;
  }

  :global(.cms-mode--edit-plugin .cms-plugin.cms-plugin--editing-inline a) {
    pointer-events: none;
  }

  :global(.cms-mode--edit-plugin .cms-plugin.cms-plugin--editing-inline:hover:after) {
    background: none;
    cursor: initial;
    display: none;
  }

  :global(.cms-focus-node) {
    box-shadow: inset 0 0 100px 0 rgba(16, 102, 204, 0.7)  !important;
  }

  :global(.cms-main--template-editor:after) {
   content: "";
   display: block;
   width: 100%;
   height: 100vh;
  }

  :global(.cms-mode--edit-node-background [data-allow-background]),
  :global(.cms-mode--edit-node-branch-block .cms-row-branch:before) {
    content: "";
    height: 5px;
    background: orange;
    display: block;
    z-index: 1000;
    position: relative;
    cursor: pointer;
  }

  :global(.cms-mode--edit-node-background [data-allow-background].cms-row::before),
  :global(.cms-mode--edit-node-background [data-allow-background].cms-row-branch::before),
  :global(.cms-mode--edit-node-background [data-allow-background].cms-col::before) {
    content: '';
    height: 7px;
    background: orange;
    display: block;
    z-index: 1000;
    position: relative;
    cursor: pointer;
  }

  :global(.cms-mode--edit-node-background .cms-col[data-node-id]::before) {
    background: cornflowerblue;
    margin-left: 10px;
    margin-right: 10px;
  }

  :global(.cms-mode--edit-plugin .cms-layout:before),
  :global(.cms-mode--remove-plugin .cms-layout:before),
  :global(.cms-mode--sort-plugin .cms-layout:before) {
    content: "";
    height: 7px;
    background: orange;
    display: block;
    z-index: 1000;
    position: relative;
    cursor: move;
  }

  :global(.cms-mode--edit-plugin .cms-layout:before),
  :global(.cms-mode--remove-plugin .cms-layout:before) {
    cursor: pointer;
  }

  .cms-background-video + .cms-background-image {
    display: none;
  }

  .cms-background-iframe {
    position: absolute;
    min-width: 100%;
    min-height: 100%;
    max-width: none;
    max-height: none;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    pointer-events: none;
  }
  .cms-iframe-container {
    position: absolute;
    width: 100%;
    height: 100%;
    padding-bottom: 52.7%;
    top: 0;
    left: 0;
  }

  @media (max-width: 700px) {
    .cms-background-iframe {
      top: 0px;
    }
  }

  @media (max-width: 1400px) {
    .cms-iframe-container {
      transform: scale(1.3);
    }
  }

  @media (max-width: 1140px) {
    .cms-iframe-container {
      padding-bottom: 100%;
      height: 100%;
    }
  }

  /* Hide picka day unbounded datapicker popup */
  :global(.pika-single.is-hidden) {
    display: none;
  }

</style>
